import apiWrapper, { create } from './helpers'

export default class MessageDistribution extends apiWrapper('/message_distributions') {
  static sendTestEmail = opts => create('/message_distributions/test', opts, console.log(opts))
}
